import baseUitvraag from '../../uitvraag.js';

const uitvraag = {

	init: function() {

		baseUitvraag.init();
	}

};

export default uitvraag;
